export default __webpack_public_path__ + "static/card-visa-platinum-3e2ed95ef3348a5d75975aaaa07295e1.png";